import { ChainId } from '@pancakeswap-libs/sdk-v2'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0xd512aB1c3650dDb220C0E6Fa970Ff3AC640eFb7f', 
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
